import UserTableService from 'app/admin/user/service/UserTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'userTable',
	topic: 'user',
	service: UserTableService,
	icon: 'person',
	editFormState: item => `/user/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'search', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'email',
			propertyType: 'String',
			type: 'LIKE'
		},
		{
			propertyName: 'registrationTimestamp',
			propertyType: 'Date',
			type: 'INTERVAL'
		},
		{
			propertyName: 'lastLoginTimestamp',
			propertyType: 'Date',
			type: 'INTERVAL',
			withTime: true
		},
		{
			propertyName: 'registrationStatus',
			propertyType: 'String',
			type: 'IN',
			items: [
				{
					value: 'NEW',
					label: 'Új'
				},
				{
					value: 'ACTIVE',
					label: 'Aktív'
				},
				{
					value: 'DELETED',
					label: 'Törölt'
				},
				{
					value: 'DISABLED',
					label: 'Letiltott'
				}
			]
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'roleList',
			type: 'text',
			sortable: false,
			disablePadding: false
		},
		{
			key: 'email',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'registrationTimestamp',
			type: 'date',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'lastLoginTimestamp',
			type: 'dateTime',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'registrationStatus',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function UserTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('userTable', reducer('userTable'))(UserTable);
